import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux"
import { hoursFunctions } from '../restaurants/Hours'
import { setUserDistanceList, setAddress } from '../../store/actions/restaurantActions'

function createUrl(location, locationList, httpResponse, setHttpResponse, count, setCount){

    let fullUrls = [];

    for(let list in locationList){
    
      //cant have the same location as a restaurant
      // for(var locs in locationList[list]){
      //   if(JSON.stringify(locationList[list][locs][1]) === JSON.stringify(location)){
      //     console.log('conflict');
      //     location = [location[list] + 0.00001, location[1]];
      //   }
      // }  
      
      var fullUrl ='';
      locationList[list].map(location=>
        fullUrl = fullUrl.concat(location[1].toString()+';')
      )
      fullUrl = fullUrl.slice(0,-1);    
      
      fullUrls[list] = fullUrl;      

    }

    //console.log(fullUrls)
    calculateDistanceMatrix(location, fullUrls, httpResponse, setHttpResponse, count,  setCount);
}

function calculateDistanceMatrix(location1, fullUrls, httpResponse, setHttpResponse, count, setCount){
    
    let arrHttp = [];
    let urls = [];
    let responses = Array(fullUrls.length).fill(false);

    for(let fullUrl in fullUrls){
      arrHttp[fullUrl] = new XMLHttpRequest();
      let url = 'https://dev.virtualearth.net/REST/v1/Routes/DistanceMatrix?origins='+location1[0]+','+location1[1]+'&destinations='+fullUrls[fullUrl]+'&travelMode=walking&distanceUnit=mi&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O'

      arrHttp[fullUrl].open("GET", url);
      arrHttp[fullUrl].send();

      
      arrHttp[fullUrl].onreadystatechange=()=>{
        if(arrHttp[fullUrl].readyState === 4 && arrHttp[fullUrl].status === 200 && httpResponse !== arrHttp[fullUrl].responseText){
          var parsedJSON = JSON.parse(arrHttp[fullUrl].responseText);
          //console.log('parsedJSON')
          //console.log(parsedJSON)
          setCount(count+1);
          //console.log('count')
          //console.log(count)
          //console.log('responses')
          //console.log(responses)
          //console.log(httpResponse)
          responses[fullUrl] = parsedJSON
          setHttpResponse(responses)     
        }
      }
    }

}

// is distanceList empty?
function isDistanceList(distanceList){
    for (var i in distanceList){
      return false}
    return true
  }

function containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
        if (list[i] === obj) {
            return true;
        }
    }
    return false;
  }

function useDistanceList(oldDistanceList) {

const [locationList, setLocationList] = useState('');
const [httpResponse, setHttpResponse] = useState('');
const [distanceList, setDistanceList] = useState({});
const [finished, setFinished] = useState(false);
const [count, setCount] = useState(0);
const [user, setUser] = useState(false);
const dispatch = useDispatch();

const restaurants = useSelector((state)=>state.firestore.ordered.restaurants);
const users = useSelector((state)=>state.firestore.data.users);
const userId = useSelector((state)=>state.firebase.auth.uid)

useEffect(()=>{
  if(users && userId){
    setUser(users[userId])
  }
},[users, userId])


useEffect(()=>{
  //console.log('count')
  //console.log(count)
},[count])

useEffect(()=>{
  
  // this should be changed to a new action that just sets distanceList = false
  if(user && restaurants && user.distanceList && Object.entries(restaurants).length !== Object.entries(user.distanceList).length){
    //console.log('reset address')
    dispatch(setAddress(user.state, user.zip, user.city, user.address, user.location, user))
  }

},[restaurants, user])

useEffect(()=>{
  
  if(user && restaurants && (user.distanceList === undefined || restaurants.length !== Object.entries(user.distanceList).length) && !finished){
     //console.log('using API');
    // find restaurants that have location data
    if(restaurants && locationList === ''){
      var locations = {};
      locations = restaurants.filter(restaurant=> restaurant.location !== undefined);
      
      var chunks = [];

      const chunkSize = 90;
      for (let i = 0; i < locations.length; i += chunkSize) {
          const chunk = locations.slice(i, i + chunkSize);
          chunks.push(chunk)
      }

      //console.log('chunks')
      //console.log(chunks)
      //console.log(chunks.length)
      //console.log(count)
      
      let locationListTmp = Array(chunks.length).fill(false);
      
      for(let chunk in chunks){
        locations = chunks[chunk];
        //console.log('locations')
        //console.log(locations)
        //console.log(chunk)
        let tmpList = []
        locations.map(location=>
          tmpList.push([location.restaurantId, location.location])
        )
        locationListTmp[chunk] = tmpList  
      }

      //console.log("updating locationListw");
      //console.log(locationListTmp);
      setLocationList(locationListTmp);   
    
      
    }
  }
  // else{
  //   if(!finished && user && user.distanceList && Object.entries(user.distanceList) && httpResponse === '' && user.distanceList!==undefined && user.distanceList && restaurants && isDistanceList(distanceList)){
  //     console.log('checking stored distance data');
  //     console.log("LENGTHS OF REST DIST2");
  //     console.log(restaurants.length);
  //     console.log(Object.entries(user.distanceList).length);
  //     if(restaurants.length === Object.entries(user.distanceList).length){
  //       console.log("EWQUAOTLL")
  //       setFinished(true)
  //     }
  //     if(restaurants.length !== Object.entries(user.distanceList).length){
  //       var locationsCheck = {};
  //       locationsCheck = restaurants.filter(restaurant=> restaurant.location !== undefined && restaurant.location !== '');
  //       var locationListCheck = [];
  //       locationsCheck.map(location=>
  //         locationListCheck.push([location.restaurantId, location.location])
  //       )
  //       const newLocations = locationListCheck.filter(location => !containsObject(location[0],Object.keys(user.distanceList)))
  //       if(newLocations.length !== 0){
  //         setLocationList(newLocations.slice(0,90))
  //         setHttpResponse('')
  //       }
  //       else if(newLocations.length === 0){
  //         setFinished(true)
  //       }
  //     }
  //   }
  // }
}
  ,[restaurants, count])

useEffect(()=>{
  
  if(!finished && locationList !== '' && httpResponse === '' && user && user.location){
    var location = user.location;
    //console.log('createUrl');     
    createUrl(location, locationList, httpResponse, setHttpResponse, count, setCount); 
  }

},[locationList, user])


useEffect(()=>{
  //console.log('count')
  //console.log(count)
  //console.log('httpresponse')  
  //console.log(httpResponse)
  //console.log(distanceList)
  //console.log(isDistanceList(distanceList))
  if(!finished && !httpResponse.includes(false) && distanceList && user && user.location){
    let distanceLists = [];
    for(let res in httpResponse){

      // create distanceList from API response
      if(httpResponse[res] !== '' && isDistanceList(distanceList)){
        //get array of distances from httpresponse
        const results = httpResponse[res].resourceSets[0].resources[0].results.map((result)=>{return(result.travelDistance)});
        //console.log('results')
        //console.log(results)
        var riffle = [];
        //console.log('locationList2')
        //console.log(locationList[res])
        for (var i = 0; i < locationList[res].length; i ++){
          riffle.push([locationList[res][i][0],results[i]]);  
        }
        distanceLists.push(Object.fromEntries(riffle))
        //console.log('riffle')
        //console.log(Object.fromEntries(riffle))

        
        // setDistanceList(Object.fromEntries(riffle));
        
      }
    }
    //console.log('distanceLists')
    //console.log(distanceLists)

    let combinedList = {};
    for(let list in distanceLists){
      //console.log('concat')
      //console.log({...combinedList, ...distanceLists[list]} )
      combinedList = {...combinedList, ...distanceLists[list]}
    }

    //console.log('combinedlist')
    //console.log(combinedList);

    if(Object.entries(combinedList) && Object.entries(combinedList).length ===  restaurants.length){
      

      if(!user.distanceList || (Object.entries(user.distanceList).length !== restaurants.length)){
        //console.log('dispatch distancelist')
        dispatch(setUserDistanceList(combinedList, user))  
      }
      
    }

  }
  else{
    //console.log('add count')
    setCount(count+1)
  }

},[locationList, httpResponse, user, distanceList, count])

  return(distanceList);
}

export default useDistanceList;